import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { EnquiryForm } from "./EnquiryForm";
import { EASE, Eyebrow } from "./Reveal";
import { useUI } from "@/context/UIContext";

export const EnquiryModal = () => {
  const { enquiry, closeEnquiry } = useUI();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") closeEnquiry();
    };
    if (enquiry.open) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [enquiry.open, closeEnquiry]);

  return (
    <AnimatePresence>
      {enquiry.open && (
        <motion.div
          data-testid="enquiry-modal"
          className="fixed inset-0 z-[120] overflow-y-auto bg-[rgba(3,3,3,0.92)] backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          onClick={closeEnquiry}
          role="dialog"
          aria-modal="true"
          aria-label="Private enquiry"
        >
          <div className="flex min-h-full items-center justify-center p-4 py-12 sm:p-8">
            <motion.div
              className="relative w-full max-w-2xl border border-[rgba(200,164,93,0.3)] bg-[#0B0B0B] px-6 py-11 shadow-[0_30px_120px_rgba(0,0,0,0.7)] sm:px-12 sm:py-14"
              initial={{ opacity: 0, y: 36, scale: 0.985 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, transition: { duration: 0.3 } }}
              transition={{ duration: 0.55, ease: EASE }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                data-testid="enquiry-modal-close"
                onClick={closeEnquiry}
                aria-label="Close enquiry"
                className="absolute right-5 top-5 p-2 text-ivory-muted transition-colors duration-300 hover:text-champagne"
              >
                <X className="h-4 w-4" strokeWidth={1.25} />
              </button>
              <Eyebrow>Private Enquiry</Eyebrow>
              <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-ivory sm:text-4xl">
                Begin the <span className="gold-text italic">conversation.</span>
              </h2>
              <p className="mt-4 max-w-md text-[13px] font-light leading-relaxed text-ivory-muted">
                Share a few details and a senior member of our team will respond personally,
                usually within the hour.
              </p>
              <EnquiryForm key={enquiry.service} initialService={enquiry.service} idPrefix="modal" />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
